import React from "react";
import "../styles/Intro.css";


const Intro = () => {

  return (

    <section className="intro">

      <div className="intro-content">

        <p className="intro-tag">
          👋 Hi, I'm
        </p>


        <h1>
          HOOMAN
        </h1>


        <h2 className="intro-role">
          Self-Taught <span>Software Developer</span>
        </h2>


        <p className="intro-description">

          I build AI, Mobile and Web Applications while
          continuously learning and improving my skills
          through real-world projects.

        </p>


        <div className="intro-buttons">


          <a
            href="https://github.com/hoomanyyy"
            target="_blank"
            rel="noreferrer"
            className="github-btn"
          >
            GitHub
          </a>



          <a
            href="#projects"
            className="project-btn"
          >
            View Projects
          </a>


        </div>


      </div>


    </section>

  );

};


export default Intro;